import React, { useEffect } from 'react';

import { ListingSearchRoomInterface } from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import SearchGuest from '@components/ui/search/SearchBarInputNext/SearchGuest/SearchGuest';

import { ResponsiveSearchDrawerItemContainer } from './styled';

type Props = {
  onApply: (hotelRooms: ListingSearchRoomInterface[]) => void;
  hotelRooms: Array<ListingSearchRoomInterface>;
  setHotelRooms: React.Dispatch<
    React.SetStateAction<Array<ListingSearchRoomInterface>>
  >;
  isBookerSearch?: boolean;
  disableAddRoomButton?: boolean;
  maxAdultCount?: number;
};

export const BookerGuestListingContainer = ({
  onApply,
  hotelRooms,
  setHotelRooms,
  isBookerSearch,
  disableAddRoomButton = false,
  maxAdultCount = 6,
}: Props) => {
  useEffect(() => {
    setHotelRooms(hotelRooms);
    onApply(hotelRooms);
  }, [hotelRooms]);

  return (
    <ResponsiveSearchDrawerItemContainer isBookerSearch={isBookerSearch}>
      <SearchGuest
        rooms={hotelRooms}
        setHotelRooms={setHotelRooms}
        popoverStyles={{ width: '570px', marginTop: '-10px' }}
        isBookerSearch={isBookerSearch}
        disableAddRoomButton={disableAddRoomButton}
        maxAdultCount={maxAdultCount}
      />
    </ResponsiveSearchDrawerItemContainer>
  );
};
export default BookerGuestListingContainer;
